/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import useStyles from "./styles";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";

import {
	MENU_HEADER_SHOW,
	TITLE_MENU_HEADER_SHOW,
	BACKGROUND_YELLOW
} from "../configPageContainer";
import { Grid } from "@material-ui/core";
import { useLocation, useHistory } from "react-router-dom";
import { useTheme } from "@material-ui/core/styles";
import { REDIRECT_CHANGE_PASSWORD, getIsApp } from "config/constant";

const HeaderPage = ({ passwordType, logout }) => {
	const classes = useStyles();
	const location = useLocation();
	const history = useHistory();
	const theme = useTheme();

	const { pathname } = location;
	const isApp = getIsApp();
	const prevUrl = history?.location?.state?.prevUrl;

	const [isShow, setShow] = useState(false);
	const [title, setTitle] = useState("");

	useEffect(() => {
		setShow(MENU_HEADER_SHOW.includes(pathname));
		if (MENU_HEADER_SHOW.includes(pathname)) {
			const pathnameConfig = pathname.replace("/", "");
			setTitle(TITLE_MENU_HEADER_SHOW[pathnameConfig]);
		} else {
			setTitle("");
		}
	}, [pathname]);

	const getBackgroundColor = pathname => {
		if (BACKGROUND_YELLOW.includes(pathname)) {
			return theme.palette.primary.main;
		}
	};

	const getColorTitle = pathname => {
		if (BACKGROUND_YELLOW.includes(pathname)) {
			return theme.palette.text.contrastText;
		}
	};

	const handleLogout = () => {
		localStorage.clear();
		if (typeof window !== undefined && isApp) {
			window?.ReactNativeWebView?.postMessage("LOGOUT");
		} else {
			logout();
		}
	};

	return (
		isShow && (
			<Grid
				classes={{ root: classes.root }}
				id="headerPage"
				style={{ background: getBackgroundColor(pathname) }}
			>
				<Grid classes={{ root: classes.header }}>
					{(!REDIRECT_CHANGE_PASSWORD.includes(passwordType) ||
						pathname !== "/change_password") && (
						<Grid
							classes={{ root: classes.btnBack }}
							style={{
								"& > svg": {
									fill: getColorTitle(pathname)
								}
							}}
							onClick={() => {
								if (prevUrl === "splash") {
									history.push("/home");
								} else {
									history.goBack();
								}
							}}
						>
							<ArrowBackIcon />
						</Grid>
					)}
					<Grid
						classes={{ root: classes.title }}
						style={{ color: getColorTitle(pathname) }}
					>
						{title}
					</Grid>
					{REDIRECT_CHANGE_PASSWORD.includes(passwordType) &&
						pathname === "/change_password" && (
							<Grid
								classes={{ root: classes.btnLogout }}
								onClick={() => {
									handleLogout();
								}}
							>
								Đăng xuất
							</Grid>
						)}
				</Grid>
			</Grid>
		)
	);
};

export default HeaderPage;
